import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'early_arm_tol',
        title: i18n.t('account.workHours.earlyEntryTolerance'),
        rules: { numeric: true},
        options: false,
        modal: ['early_arm_tol'],
        data: ['early_arm_tol',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'tardy_dis_tol',
        title: i18n.t('account.workHours.lateEntryTolerance'),
        rules: { numeric: true},
        options: false,
        modal: ['tardy_dis_tol'],
        data: ['tardy_dis_tol',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'early_dis_tol',
        title: i18n.t('account.workHours.earlyClosingTolerance'),
        rules: { numeric: true},
        options: false,
        modal: ['early_dis_tol'],
        data: ['early_dis_tol',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'tardy_arm_tol',
        title: i18n.t('account.workHours.lateClosingTolerance'),
        rules: { numeric: true},
        options: false,
        modal: ['tardy_arm_tol'],
        data: ['tardy_arm_tol',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'non_over_time',
        title: i18n.t('account.workHours.outOfHoursTolerance'),
        rules: { numeric: true},
        options: false,
        modal: ['non_over_time'],
        data: ['non_over_time',],
        additionalButton: false,
        checkBox: false
    },
    
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/workhoursTolerance.js